var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.49988C14.3432 2.49988 13 3.84302 13 5.49988V19.4999C13 21.1567 14.3432 22.4999 16 22.4999C17.6569 22.4999 19 21.1567 19 19.4999V5.49988C19 3.84302 17.6569 2.49988 16 2.49988ZM17 19.4998C17 20.052 16.5523 20.4998 16 20.4998C15.4477 20.4998 15 20.052 15 19.4998V5.49975C15 4.94747 15.4477 4.49975 16 4.49975C16.5523 4.49975 17 4.94747 17 5.49975V19.4998ZM8 2.49988C6.34315 2.49988 5 3.84302 5 5.49988V19.4999C5 21.1567 6.34315 22.4999 8 22.4999C9.65685 22.4999 11 21.1567 11 19.4999V5.49988C11 3.84302 9.65685 2.49988 8 2.49988ZM9.00002 19.4998C9.00002 20.052 8.5523 20.4998 8.00002 20.4998C7.44773 20.4998 7.00002 20.052 7.00002 19.4998V5.49975C7.00002 4.94747 7.44773 4.49975 8.00002 4.49975C8.5523 4.49975 9.00002 4.94747 9.00002 5.49975V19.4998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.f71f1842.svg";
export { ForwardRef as ReactComponent };